import dayjs from "dayjs";
import {
  Space,
  Button,
  DatePicker,
  TimePicker,
  Select,
  Spin,
  notification,
} from "antd";
import { useEffect, useState } from "react";
import {
  useBookOrder,
  useDeleteShipment,
  useGetSlots,
  useBookReturnShipment,
} from "../../hooks/useOrders";
import useLogout from "../../hooks/useLogout";
import CommonTable from "../../commonComponents/Table/table";
import "./courierList.scss";
import moment from "moment";
const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY"];

const CourierList = ({ isReturningBox = false, ...props }) => {
  const [selectedCourierId, setSelectedCourierId] = useState("");
  const [pickupDate, setPickupDate] = useState("");
  const [slotList, setSlotList] = useState([]);
  const [selectedSlot, setSelectedSlot] = useState({
    pickupDate: "",
    pickupTimeSlotId: "",
  });
  const [api, contextHolder] = notification.useNotification();
  const { logout } = useLogout();

  const onBookingSuccess = () => {
    api.success({
      message: "Great!",
      description: "Shipment created successfully",
      placement: "topRight",
    });
  };

  const { mutate: bookOrderData } = useBookOrder(onBookingSuccess);
  const { mutate: bookReturnShipment } =
    useBookReturnShipment(onBookingSuccess);

  const { mutate: deleteShipmentData } = useDeleteShipment();

  const onSuccess = (data) => {
    setSlotList(data.data);
  };
  const onError = (err) => {
    if (err?.response?.status === 401) logout();
  };
  const { refetch } = useGetSlots(onSuccess, onError, selectedCourierId);

  const handleAction = (rowData) => {
    setSelectedSlot({
      pickupDate: "",
      pickupTimeSlotId: "",
    });
    setSlotList([]);
    // let storeId = rowData.courier_id;
    // storeId.push(rowData.courier_id);
    setSelectedCourierId(rowData.courier_id);
    props.chooseMessage(rowData, pickupDate, props?.orderId);
  };

  const onChangeDate = (_, dateString) => {
    setPickupDate(dateString);
  };

  const orderBook = () => {
    const tempData = {
      orderId: props?.orderId,
      boxId: props?.boxId,
      assignedStudioId: props?.assignedStudioId,
      selectedCourierId,
      easyshipId: props?.data?.easyship_shipment_id,
      pickupDate: selectedSlot.pickupDate,
      pickupTimeSlotId: selectedSlot.pickupTimeSlotId,
    };

    if (isReturningBox) {
      delete tempData["boxId"];
      tempData["returnBoxId"] = props?.boxId;
      bookReturnShipment(tempData);
      props?.setCourierFlag(false);
    } else {
      bookOrderData(tempData);
      props?.setCourierFlag(false);
    }
  };

  const columns = [
    { title: "Courier", dataIndex: "courier_name", key: "courier_name" },
    {
      title: "Delivery time",
      dataIndex: ["min_delivery_time", "max_delivery_time"],
      key: `min_delivery_time -max_delivery_time`,
      render: (_, record) => (
        <Space size="middle">
          <span>{`${record.min_delivery_time}- ${record.max_delivery_time} working days`}</span>
        </Space>
      ),
    },
    {
      title: "Tracking",
      dataIndex: "tracking_rating",
      key: "tracking_rating",
    },
    {
      title: "Rating",
      dataIndex: "easyship_rating",
      key: "easyship_rating",
    },
    { title: "Service options", dataIndex: "so", key: "so" },
    {
      title: "Remarks",
      dataIndex: "courier_remarks",
      key: "courier_remarks",
    },
    {
      title: "Import tax",
      dataIndex: "import_tax_charge",
      key: "import_tax_charge",
    },
    { title: "Total cost", dataIndex: "total_charge", key: "total_charge" },
    { title: "Currency", dataIndex: "currency", key: "currency" },
    {
      title: "",
      key: "key",
      dataIndex: "key",
      render: (_, record) => (
        <Space size="middle">
          <Button
            onClick={() => handleAction(record)}
            type={
              selectedCourierId == record.courier_id ? "primary" : "default"
            }
          >
            {selectedCourierId == record.courier_id ? "Selected" : "Select"}
          </Button>
        </Space>
      ),
    },
  ];

  const deleteShipment = () => {
    let tempData = {
      shipmentId: props?.data?.easyship_shipment_id,
    };
    deleteShipmentData(tempData);
    props?.setCourierFlag(false);
  };

  function disabledPreviousDate(current) {
    return current && current < moment().endOf("day");
  }

  const today = moment();
  useEffect(() => {
    if (selectedCourierId != "") refetch();
  }, [selectedCourierId]);
  return (
    <div className="courier_container">
      {contextHolder}
      {props.isLoading && <Spin className="dialogue-spin-center" />}
      <CommonTable
        rowClassName={(record) =>
          record.courier_id !== selectedCourierId ? "in_active" : "active"
        }
        columns={columns}
        data={props?.data?.rates}
        pagination={false}
      />

      <div className="date_picker mt-1 mb-1">
        {slotList && slotList.length > 0 && (
          <Select
            autoFocus
            style={{ width: 150 }}
            placeholder="Choose a Date"
            //  value={selectedSlot.pickupDate}
            options={slotList.map((elm) => {
              return {
                value: elm.date,
                label: elm.date,
              };
            })}
            onChange={(val) =>
              setSelectedSlot({
                pickupDate: val,
                pickupTimeSlotId: "",
              })
            }
          />
        )}

        {slotList && slotList.length > 0 && (
          <Select
            value={selectedSlot.pickupTimeSlotId}
            style={{ width: 150 }}
            className="ml-1"
            placeholder="Choose a Slot"
            options={slotList
              .find((el) => el.date == selectedSlot.pickupDate)
              ?.time_slots?.map((elm) => {
                return {
                  value: elm.time_slot_id,
                  label: `${elm.from_time} - ${elm.to_time}`,
                };
              })}
            onChange={(val) =>
              setSelectedSlot({
                ...selectedSlot,
                pickupTimeSlotId: val,
              })
            }
            disabled={selectedSlot.pickupDate == ""}
          />
        )}
        {/* <DatePicker
          defaultValue={dayjs("01/01/2015", dateFormatList[0],today)}
          style={{ margin: "5px" }}
          format={dateFormatList}
          onChange={onChangeDate}
          disabledDate={disabledPreviousDate}
          // defaultPickerValue={today}
          // value={currentDate}
        />
        <TimePicker style={{ margin: "5px" }} /> */}
      </div>
      <div className="btn_legend">
        <Button onClick={deleteShipment}>Cancel</Button>
        <Button
          onClick={orderBook}
          className="ml-1"
          disabled={selectedSlot.pickupTimeSlotId == ""}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};
export default CourierList;
